// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dqbIF {\n  margin: var(--spacing-md) !important;\n  padding: unset;\n}\n\n.dqbIF svg {\n  height: var(--schoolinks-icon-xl) !important;\n  width: var(--schoolinks-icon-xl) !important;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"schooLinksLogo": "dqbIF"
};
export default ___CSS_LOADER_EXPORT___;
